"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isDevelopment = function () { return process.env.NODE_ENV === 'development'; };
exports.default = isDevelopment;
